import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "components/sales/downloadDocView/documentView";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import { getDropDownData } from "services/redux/sales/postSales/b2bAlliance/action";
import AssignLocation from "../AssignLocation/AssignLocation";

const EmployeeRequest = ({
  match,
  getoffRoleEmployeesData,
  getEmployeesListing = [],
  getDataForDropdown,
  getDropdownDatas = [],
  updateStatusOffroleEmployee,
  statusUpdationByBusinessHead = [],
  departmentDropdownData,
  departmentDropwdownResponse = [],
  teamDropdownData,
  teamDropdownResponse = [],
  roleDropdownData,
  roleDropdownResponse = [],
  reportingManagerDropdownData,
  reportingManagerResponse = [],
  citiesDropdownData,
  citiesDropdownResponse = [],
  zonesDropdownData,
  zonesDropdownResponse = [],
  assignLocationsToUser,
  areasDropdownData,
  areasDropdownResponse = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({
    department_id: "",
    team_id: "",
    date_of_joining: "",
    city_id: "",
    employee_type: "",
    role_id: "",
    action_remark: "",
    status: "",
    designation_id: "",
    leadx_login_preference: "",
  });
  const [isModal, setIsModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [message, setMessage] = useState("");
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState("");
  const [showAssignLocationPopup, setShowAssignLocationPopup] = useState(false);
  const [locationData, setLocationData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getDataForDropdown();
      await getoffRoleEmployeesData(1, [], match?.params?.id, null, "OFFROLE");
      await departmentDropdownData();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem("profileDetails");
    if (storedData) {
      const parsed = JSON.parse(storedData);

      if (parsed.length > 0) {
        setTeamId(parsed[0].team_id);
      }
    }
  }, []);

  useEffect(() => {
    if (
      getEmployeesListing?.response?.data?.data?.length > 0 &&
      !departmentId
    ) {
      const details = getEmployeesListing.response.data.data[0];
      setData({
        department_id: details?.department_id || "",
        team_id: teamId || "",
        designation_id: details?.designation_id || "",
        date_of_joining: details?.date_of_joining || "",
        city_id: details?.city_id || "",
        employee_type: details?.employee_type || "",
        role_id: details?.role_id || "",
        action_remark: "",
      });
      handleDepartmentChange(details?.department_id);
      setDepartmentId(details?.department_id);
    }
  }, [getEmployeesListing, departmentId]);

  const today = new Date();
  const minDate = new Date(today);
  minDate.setDate(today.getDate() - 2);
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 2);

  const handleModalHide = () => {
    setIsModal(false);
  };

  const handleSuccessModalHide = () => {
    setIsSuccessModal(false);
  };

  useEffect(() => {
    if (departmentId) {
      const fetchData = async () => {
        await roleDropdownData(departmentId);
        await citiesDropdownData();
        setIsLoading(false);
      };
      fetchData();
    }
  }, [departmentId]);

  const handleSubmit = async () => {
    formData["status"] = 1;
    formData["id"] = match?.params?.id;
    formData["approve_request"] = true;
    formData["location_data"] = locationData?.location_data;
    setIsLoading(true);
    const res = await updateStatusOffroleEmployee(formData);
    if (res?.status == 200) {
      setMessage(res?.message);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  const handleReject = async () => {
    formData["status"] = 2;
    formData["id"] = match?.params?.id;
    formData["approve_request"] = true;
    setIsModal(false);
    setIsLoading(true);
    const res = await updateStatusOffroleEmployee(formData);
    if (res?.status == 200) {
      setMessage(res?.message);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  const handleDepartmentChange = async (departmentId) => {
    setIsLoading(true);
    await teamDropdownData(departmentId);
    setIsLoading(false);
  };

  const handleRoleChange = async (roleId, roleLevel) => {
    setIsLoading(true);
    await reportingManagerDropdownData(departmentId, teamId, roleLevel);
    setIsLoading(false);
  };

  const handleCityChange = async (cityIds) => {
    setIsLoading(true);
    await zonesDropdownData(cityIds);
    setIsLoading(false);
  };

  return (
    <Layout title={"Employee Details"} isGoback isLoading={isLoading}>
      {getEmployeesListing?.response?.data?.data?.length > 0 ? (
        getEmployeesListing.response.data.data.map((details, index) => (
          <div key={index} className="panel-card">
            <div className="panel-heading">{localization.employeeDetails}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={localization.fullName}
                  data={details?.employee_name ?? localization.na}
                />
                <DivLayout
                  heading={localization.fathersName}
                  data={details?.employee_father_name ?? localization.na}
                />
                <DivLayout
                  heading={localization.dateOfBirth}
                  data={details?.date_of_birth ?? localization.na}
                />
                <DivLayout
                  heading={localization.phoneNumber}
                  data={details?.phone_number ?? localization.na}
                />
                <DivLayout
                  heading={localization.emergencyContactName}
                  data={details?.emergency_contact_name ?? localization.na}
                />
                <DivLayout
                  heading={localization.emergencyContactNumber}
                  data={
                    details?.emergency_contact_phone_number ?? localization.na
                  }
                />
                {(details?.status == 0 ||
                  details?.status == 1 ||
                  details?.status == 2) && (
                  <DivLayout
                    heading={localization.status}
                    data={details?.status_name ?? localization.na}
                  />
                )}
                {(details?.status == 3 || details?.status == 4) && (
                  <DivLayout
                    heading={localization.employeeStatus}
                    data={details?.status ?? localization.na}
                  />
                )}
                <DivLayout
                  heading={localization.aadharNumber}
                  data={details?.aadhar_number ?? localization.na}
                />
                <DivLayout
                  heading={"Hiring Location"}
                  data={details?.city_name ?? localization.na}
                />
                <DivLayout
                  heading={localization.aadharStatus}
                  data={
                    <span
                      style={{
                        color:
                          details?.aadhar_status === "Verified"
                            ? "green"
                            : "red",
                      }}
                    >
                      {details?.aadhar_status ?? localization.na}
                    </span>
                  }
                />

                <div
                  className="col-md-12"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="col-md-6">
                    {details?.aadhar_document && (
                      <DocumentView
                        title={localization.aadharImage}
                        attachment={details?.aadhar_document}
                      />
                    )}
                  </div>
                  <div className="col-md-6">
                    {details?.pan_document && (
                      <DocumentView
                        title={localization.panImage}
                        attachment={details?.pan_document}
                      />
                    )}
                  </div>
                </div>
              </div>

              <hr></hr>

              <div className="row mt-3">
                <div className="col-md-4">
                  <DropDownInput
                    data={departmentDropwdownResponse?.response?.data}
                    label={localization.department}
                    required
                    errorMsg={localization.required}
                    isStarRequired={true}
                    getValueById={formData.department_id}
                    disabled
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    data={teamDropdownResponse?.response?.data}
                    label={localization.team}
                    required
                    getIdValue={(val) => {
                      setData({ ...formData, team_id: val.id });
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                    getValueById={formData.team_id}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    data={getDropdownDatas?.response?.data?.designations}
                    label={localization.designation}
                    required
                    getIdValue={(val) => {
                      if (formData.designation_id !== val.id) {
                        setData({ ...formData, designation_id: val.id });
                      }
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                    getValueById={formData.designation_id}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    label={"Hiring Location"}
                    required
                    data={getDropdownDatas?.response?.data?.locations}
                    isStarRequired={true}
                    errorMsg={localization.required}
                    getIdValue={(val) => {
                      setData({ ...formData, city_id: val.id });
                    }}
                    getValueById={formData?.city_id}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    data={getDropdownDatas?.response?.data?.employee_types}
                    label={localization.employeeType}
                    required
                    getIdValue={(val) => {
                      if (formData.employee_type !== val.id) {
                        setData({ ...formData, employee_type: val.id });
                      }
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                    getValueById={formData.employee_type}
                  />
                </div>
                <div className="col-md-4">
                  <DatePicker
                    label={localization.dateOfJoining}
                    required={true}
                    minimumDate={minDate}
                    maxDate={maxDate}
                    defaultValue={formData.date_of_joining}
                    value={details?.date_of_joining}
                    handleChange={(val) => {
                      setData({
                        ...formData,
                        date_of_joining: val,
                      });
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    data={roleDropdownResponse?.response?.data}
                    label={"Fusion/LeadX Role"}
                    required
                    getIdValue={(val) => {
                      if (!val.id) return;
                      const selectedItem =
                        roleDropdownResponse?.response?.data.find(
                          (item) => item.id === val.id
                        );
                      const level = selectedItem?.level || null;

                      if (formData.role_id !== val.id) {
                        setData({ ...formData, role_id: val.id });
                      }

                      handleRoleChange(val.id, level);
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                  />
                </div>

                <div className="col-md-4">
                  <ConstantInput
                    label={"Company Park+ Email"}
                    errorMsg={localization.required}
                    type="password"
                    required
                    isStarRequired={true}
                    handleChange={(val) => {
                      setData({
                        ...formData,
                        company_email_id: val,
                      });
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                  />
                </div>

                <div className="col-md-4">
                  <ConstantInput
                    label={"Confirm Park+ Email"}
                    errorMsg={
                      formData.confirm_email_id &&
                      formData.confirm_email_id !== formData.company_email_id
                        ? "Emails do not match"
                        : localization.required
                    }
                    type="text"
                    required
                    isStarRequired={true}
                    handleChange={(val) => {
                      setData({
                        ...formData,
                        confirm_email_id: val,
                      });
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                  />
                </div>

                <div className="col-md-4">
                  <DropDownInput
                    data={reportingManagerResponse?.response?.data}
                    label={"Reporting To"}
                    required
                    getIdValue={(val) => {
                      if (formData.reporting_to !== val.id) {
                        setData({ ...formData, reporting_to: val.id });
                      }
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownInput
                    data={[
                      { id: "1", name: "Web" },
                      { id: "2", name: "App" },
                      { id: "3", name: "Both" },
                    ]}
                    label={"LeadX Login Preference"}
                    required
                    getIdValue={(val) => {
                      if (formData.leadx_login_preference !== val.id) {
                        setData({
                          ...formData,
                          leadx_login_preference: val.id,
                        });
                      }
                    }}
                    errorMsg={localization.required}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-4">
                  <Button
                    className="btn btn-sm"
                    onClick={() => setShowAssignLocationPopup(true)}
                  >
                    Assign Location
                  </Button>
                </div>
              </div>

              {details?.status == 5 && (
                <div
                  className="col-md-12 d-flex mb-4 mt-3"
                  style={{ justifyContent: "start" }}
                >
                  <Button
                    className="btn btn-sm btn-danger mr-4"
                    onClick={() => setIsModal(true)}
                  >
                    Reject
                  </Button>
                  <Button
                    className="btn btn-sm btn-success"
                    onClick={handleSubmit}
                  >
                    Approve
                  </Button>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div>
          <img src={Images?.NoData} alt="" width="100%" />
        </div>
      )}

      <AssignLocation
        showAssignLocationPopup={showAssignLocationPopup}
        onClosePopup={() => setShowAssignLocationPopup(false)}
        locationAssignUserId={
          getEmployeesListing?.response?.data?.data[0]?.user_id
        }
        citiesDropdownResponse={citiesDropdownResponse}
        zonesDropdownResponse={zonesDropdownResponse}
        zonesDropdownData={zonesDropdownData}
        assignLocationsToUser={assignLocationsToUser}
        areasDropdownData={areasDropdownData}
        areasDropdownResponse={areasDropdownResponse}
        approvalCase={true}
        setLocationData={setLocationData}
      />

      <ModalPop
        title={localization.reasonForRejection}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="col-md-12">
          <ConstantInput
            label={localization.reason}
            errorMsg={localization.required}
            type="text"
            required
            isStarRequired={true}
            handleChange={(val) => {
              setData({
                ...formData,
                action_remark: val,
              });
            }}
          />
        </div>
        <div className="col-md-12">
          <Button className="btn btn-primary" onClick={handleReject}>
            Submit
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={isSuccessModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{message}</h5>
          <Link
            to={`${baseUrl}/offrole-employees-list`}
            className="btn btn-primary mb-4"
          >
            {"Go back to list"} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default EmployeeRequest;
